
try {
  process.dlopen(module, __dirname + require("path").sep + __webpack_public_path__ + "061aca7bf31c734e2cfba040f84d8b4d.node");
} catch (error) {
  throw new Error('node-loader:\n' + error);
}
